export const startDate = new Date('2023-08-18T19:01:00.000Z');
export const endDate = new Date('2023-08-20T23:59:00.000Z');

export const teamFormationEndDate = new Date('2023-07-20T23:59:00.000Z');

export const discordInviteLink = "https://go.hackthe6ix.com/2023-discord";